import { EnrolmentRoute } from "@/constants/routes/enrolment.ts"
import { MyAccountRoute } from "@/constants/routes/myAccount.ts"
import { PublicRoute } from "@/constants/routes/public.ts"
import { Component } from "vue"
import { RouteRecordRaw } from "vue-router"

import RouterViewPassthrough from "./RouterViewPassthrough.vue"
import { enrolmentWebRoutes } from "./routes/enrolment.web.routes"
import { myAccountWebRoutes } from "./routes/myAccount.web.routes"

// The app serves from the root (no Vite base). Each journey is mounted under a
// passthrough parent that renders it through its RouterView: My Account under
// /myaccount, the enrolment quote under /energy/quote. A bare "/" redirects to
// My Account and the shared chrome lives in App.web.vue.
const routesDefinition = [
  {
    path: "/",
    redirect: MyAccountRoute.home,
  },
  {
    path: PublicRoute.maintenance,
    component: (): Promise<Component> => import("@/views/MaintenanceView.vue"),
    meta: {
      requiresAuth: false,
      requiresAnon: false,
    },
  },
  {
    path: PublicRoute.troubleshootingIhd,
    name: "troubleshootingIhd",
    component: (): Promise<Component> =>
      import("@/views/TroubleshootingIhdView.vue"),
    meta: {
      requiresAuth: false,
      requiresAnon: false,
      metaTitle: "In Home Display (IHD) Troubleshooting - So Energy",
    },
  },
  {
    path: PublicRoute.movingIn,
    name: "movingIn",
    component: (): Promise<Component> => import("@/views/MovingInView.vue"),
    meta: {
      requiresAuth: false,
      requiresAnon: false,
      metaTitle: "Moving In - So Energy",
    },
  },
  {
    path: PublicRoute.ourTariffs,
    name: "ourTariffs",
    component: (): Promise<Component> =>
      import("@/views/our-tariffs/OurTariffsView.vue"),
    meta: {
      requiresAuth: false,
      requiresAnon: false,
      metaTitle: "Our Tariffs - So Energy",
    },
  },
  {
    path: MyAccountRoute.home,
    component: RouterViewPassthrough,
    children: [...myAccountWebRoutes],
  },
  {
    path: EnrolmentRoute.enrolment,
    component: RouterViewPassthrough,
    children: [...enrolmentWebRoutes],
  },
  {
    path: "/:pathMatch(.*)*",
    name: "notFound",
    component: (): Promise<Component> => import("@/views/NotFound.vue"),
    meta: {
      hideBackButton: true,
    },
  },
] satisfies readonly RouteRecordRaw[]

export default routesDefinition
